import Cookies from 'js-cookie';
import { CookieEnum, COOKIES_REQUIRING_CONSENT } from '../hooks/cookie.hook.js';
export const allowedToUseCookie = (name) => {
    return !COOKIES_REQUIRING_CONSENT.includes(name) || Cookies.get(CookieEnum.ACCEPT_AT_COOKIES) == 'true';
};
export const getCookieValue = (name) => {
    if (name) {
        if (allowedToUseCookie(name)) {
            return Cookies.get(name);
        }
    }
};
export const getCookies = () => {
    return Cookies.get();
};
export const setCookieValue = (name, value, expires) => {
    if (!!expires && allowedToUseCookie(name)) {
        return Cookies.set(name, value, { expires: expires });
    }
    if (allowedToUseCookie(name)) {
        return Cookies.set(name, value);
    }
};
export const removeCookie = (name, options) => {
    return Cookies.remove(name, options);
};
export const getJSON = (name) => {
    if (allowedToUseCookie(name)) {
        return Cookies.getJSON(name);
    }
};
